/* eslint-disable no-underscore-dangle */
import { GuideStep, GuideStepTypes } from './GuideStep';

export class GuideStepDone extends GuideStep {
  constructor(title: string, destription: string) {
    super(title, destription, []);
    this._type = GuideStepTypes.done;
  }
}
